import { Injectable, InjectionToken, Inject } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { Store } from "src/app/state/core";
import { RecordRouteNaviation } from "./router.actions";

const ROUTE_HISTORY_DEFAULT_LIMIT = 10;
export const ROUTE_HISTORY_LIMIT = new InjectionToken<number>('ROUTE_HISTORY_LIMIT', {
  providedIn: 'root',
  factory: () => ROUTE_HISTORY_DEFAULT_LIMIT // This is your default limit
});

export interface RouterStateModel {
    breadcrumbs: string[];
}

@State<RouterStateModel>({
    name: 'routerEvents',
    defaults: {
        breadcrumbs: []
    }
})
@Injectable()
export class RouterState {
    constructor(@Inject(ROUTE_HISTORY_LIMIT) private routeHistoryLimit: number) {
        // If the token isn't provided, use your default value
        this.routeHistoryLimit = this.routeHistoryLimit ?? ROUTE_HISTORY_DEFAULT_LIMIT;
    }

    @Action(RecordRouteNaviation)
    recordRouteNaviationEvent(ctx: StateContext<RouterStateModel>, { event }: RecordRouteNaviation) {
        const state = ctx.getState().breadcrumbs;
        const routeUrl = event.urlAfterRedirects || event.url;
        if (state[state.length - 1] === routeUrl) return;

        const breadcrumbs = [...state];
        breadcrumbs.push(routeUrl);
        while (breadcrumbs.length > this.routeHistoryLimit) {
            breadcrumbs.shift();
        }
        ctx.patchState({ breadcrumbs });
    }

    static getBreadCrumbsTrail(size: number = 5) {
        return Store.createSelector([RouterState], (state: RouterStateModel) => {
            const breadcrumbs = [...state.breadcrumbs];
            return breadcrumbs.slice(-size).reverse();
        });
    }
}
